// Implements: F-UIX-010, F-UIX-014
/**
 * Where the API is served (decision OD-2).
 *
 * The edge sends this prefix to the backend and every other path to the SPA, so an address of the
 * app such as `/mockups/:id` can never be answered by the API. Every request path of the API
 * clients starts with it; the addresses of the SPA's own router never do.
 */
export const API_BASE = "/api";
